import Component from "../../component";
import {CurrencyUpdaterConfig} from "../../services/currency_updater";

export const CurrencySwitcherConfig = {
    signature: 'CurrencySwitcher',
    baseHtmlClass: 'currency_switcher',
    selector: '.currency_switcher'
};

export class CurrencySwitcher extends Component {

    static applyToAll() {
        document.querySelectorAll(CurrencySwitcherConfig.selector).forEach((element) => {
            if (!CurrencySwitcher.isElementComponentized(element, CurrencySwitcherConfig.signature)) new CurrencySwitcher(element);
        });
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: CurrencySwitcherConfig
        });

        this.selectElement = this.element.querySelector('select');

        if (this.selectElement) {

            // Set the selected option to match the current currency…
            this.selectElement.value = getCurrentCurrency();

            this.selectElement.addEventListener('change', (event) => {
                const value = event.target.value;
                if (value !== getCurrentCurrency()){
                    const currencyChangeEvent = new CustomEvent(CurrencyUpdaterConfig.changedEventName, {detail: {currency: value}});
                    window.dispatchEvent(currencyChangeEvent);
                }
            });

        }

        this.inited = true;
        this.render();
    }


    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');
    }

}

function getCurrentCurrency() {
    return window.Currency.currentCurrency;
}
